import { useMutation, useQueryClient } from "@tanstack/react-query";
import { siteNotificationsApi } from "../api/lib/notifications";
import { notificationsKeys } from "../api/lib/query-keys/notifications";
import { ApiError } from "src/types/interfaces/api-error";
import toast from "react-hot-toast";
import { t } from "i18next";

export const useMarkSingleNotificationAsUnread = (
  onSuccess?: (data: { updatedCount: number }) => void,
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (notificationToken: string) => {
      return siteNotificationsApi.markSingleNotificationAsUnread(notificationToken);
    },
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey: notificationsKeys.all });
      onSuccess?.(data);
    },
    onError: (err: ApiError) => {
      if (err?.response?.data?.message) {
        toast.error(err?.response?.data?.message);
      } else toast.error(t("notifications:common.failedToUpdateNotificationStatus"));
    },
  });
};
